module.exports = __webpack_public_path__ + "media/images/pic/meeting-d80499c6bdfe6ca9a09586f3baba0f16.webp";